<div class="bg-white">
    <div class="header bg-white mt-3">
        <div class="import-text">
            Upload document
        </div>
        <app-button variant="filled" severity="contrast" icon="pi pi-times" (clicked)="this.dialogRef.close()" />
    </div>
    <div class="body p-3">
        <app-file-drop [fileTypes]="allowedFileTypes" (uploadData)="onFileUploaded($event)"
            (removeFile)="onFileRemove($event)" [maxFileSize]="100 * 1000* 1000"
            [existingFiles]="data.allowMultiple ? files : (isFileAdded && fileData ? [fileData] : [])"
            [multiple]="multiple" />
    </div>
    <div class="footer">
        <app-button variant="filled" severity="primary" (clicked)="createContract()" [enableThrottle]="true" [disabled]="!isFileAdded"
            [loading]="loading" label="Save" icon="pi pi-save" />
    </div>
</div>